/**
 * Size of an icon beside the app's 12 to 14 px text, in CSS pixels: menu
 * rows, sidebar section and row actions, panel headers.
 */
export const ICON_PX = 16;
/** Size of the square button around an icon of {@link ICON_PX}, in CSS pixels. */
export const ICON_BUTTON_PX = 24;
